module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"switchHtmlView":"Display the Html view","switchMarkdownView":"Display the Markdown view"},"fr":{"switchHtmlView":"Afficher la vue HTML","switchMarkdownView":"Afficher la vue Markdown"},"de":{"switchHtmlView":"Zeigt die HTML-Ansicht an","switchMarkdownView":"die Markdown-Ansicht anzeigen"}}')
  delete Component.options._Ctor
}
